import { render, staticRenderFns } from "./HrdcEventDetails.vue?vue&type=template&id=e2b7dd06&scoped=true&"
import script from "./HrdcEventDetails.vue?vue&type=script&lang=js&"
export * from "./HrdcEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./HrdcEventDetails.vue?vue&type=style&index=0&id=e2b7dd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b7dd06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
